import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from './AxiosClient'

// --- N-Tier (`/ntapi/v2/ntier/*`) — only non–N-Tier APIs were removed from this module. ---

export const downloadNtierSkuBulkTemplate = createAsyncThunk(
  'ntier/downloadTemplate',
  async (params, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      '/ntapi/v2/ntier/download-ntier-sku-bulk-template',
      params,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
      'blob',
    )
  },
)

export const createProject = createAsyncThunk(
  'ntier/createproject',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/create-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const launchSkuMapping = createAsyncThunk(
  'ntier/launchskumapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/launch-sku-mapping', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProjects = createAsyncThunk(
  'ntier/getprojects',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/get-projects', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProjectDetails = createAsyncThunk(
  'ntier/getprojectdetails',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/get-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const updateProjectDetails = createAsyncThunk(
  'ntier/updateProjectDetails',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/update-project-details',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const regenerateProjectStrategy = createAsyncThunk(
  'ntier/regenerateProjectStrategy',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/regenerate-project-strategy',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const updateSkuMappingResponseData = createAsyncThunk(
  'ntier/updateSkuMappingResponseData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/update-sku-mapping-response-data',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const downloadMapping = createAsyncThunk(
  'ntier/downloadMapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const body =
      payload && typeof payload === 'object'
        ? {
            ...payload,
            ...(payload.sku_table_id != null && !Array.isArray(payload.sku_table_id)
              ? { sku_table_id: [payload.sku_table_id] }
              : {}),
          }
        : payload
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/download-mapping',
      body,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
      'blob',
    )
  },
)

export const relaunchSkuMapping = createAsyncThunk(
  'ntier/relaunchSkuMapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/relaunch-sku-mapping',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const relaunchCustomUserPrompt = createAsyncThunk(
  'ntier/relaunchCustomUserPrompt',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/relaunch-custom-user-prompt',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const getProjectSkusView = createAsyncThunk(
  'ntier/getprojectskusview',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/get-project-skus-view', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSkuMappingsById = createAsyncThunk(
  'ntier/getskumappingsbyid',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/get-sku-mappings-by-id', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const fetchSkuDetailsFromGenAi = createAsyncThunk(
  'ntier/fetchskudetailsfromgenai',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/fetch-sku-details-from-genai', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const fetchDropdowns = createAsyncThunk(
  'ntier/getdropdowns',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/ntapi/v2/ntier/dropdowns', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const createProjectCustom = createAsyncThunk(
  'ntier/createprojectcustom',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/launch-custom-user-prompt', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const uploadProjectMapping = createAsyncThunk(
  'ntier/uploadprojectmapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/upload-project-mapping', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const verifyWithAiAgent = createAsyncThunk(
  'ntier/verifywithaiagent',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/verify-with-ai-agent', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const cancelSkuMappings = createAsyncThunk(
  'ntier/cancelSkuMappings',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/cancel-sku-mappings',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

/** GET `/ntapi/v2/ntier/ntier-settings` — not wired to UI yet. */
export const getNtierSettings = createAsyncThunk(
  'ntier/getNtierSettings',
  async (params, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/ntapi/v2/ntier/ntier-settings', params, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

/** POST `/ntapi/getEmbedToken` — same route as legacy `/api/getEmbedToken`; `resolveNtapiRequestUrl` sends to host `/ntapi/...`. */
export const getEmbedPowerBiTokenAsync = createAsyncThunk(
  'managementreport/getEmbedPowerBiToken',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/getEmbedToken', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

/** GET `/ntapi/v2/ntier/file-upload-logs` — N-Tier Map Power BI upload modal prerequisite. */
export const getNtierFileUploadLogs = createAsyncThunk(
  'ntier/getNtierFileUploadLogs',
  async (params, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/ntapi/v2/ntier/file-upload-logs', params, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

/** POST `/ntapi/v2/ntier/submit-transform-mappings-file` — multipart field `filedata`. */
export const submitNtierTransformMappingsFile = createAsyncThunk(
  'ntier/submitTransformMappingsFile',
  async (formData, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/ntapi/v2/ntier/submit-transform-mappings-file',
      formData,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

/** POST `/ntapi/v2/ntier/upsert-ntier-settings` — watchlist and other keyed N-Tier settings. */
export const upsertNtierSettings = createAsyncThunk(
  'ntier/upsertNtierSettings',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v2/ntier/upsert-ntier-settings', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// --- N-Tier Phase 1 (ComingSoon): `/ntapi/v1/<action>` (no `ntier` segment) — Phase 2: `/ntapi/v2/ntier/*`. ---
export const verifyWithAiAgentPhase1 = createAsyncThunk(
  'ntierPhase1/aiagent/verify',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v1/verify-with-ai-agent', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDeepResearchRequest = createAsyncThunk(
  'ntierPhase1/deepResearch/request',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v1/deep-research-request', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDeepResearchLaunch = createAsyncThunk(
  'ntierPhase1/deepResearch/launch',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v1/deep-research-launch', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDeepResearchRequests = createAsyncThunk(
  'ntierPhase1/deepResearch/requests',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/ntapi/v1/get-deep-research-requests', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDeepResearchResult = createAsyncThunk(
  'ntierPhase1/deepResearch/result',
  async (id, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v1/deep-research-result', { id }, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const updateDeepResearchResponse = createAsyncThunk(
  'ntierPhase1/deepResearch/update',
  async (data, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v1/update-deep-research-response', data, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const cancelDeepResearch = createAsyncThunk(
  'ntierPhase1/deepResearch/cancel',
  async (data, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/ntapi/v1/cancel-deep-research', data, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// --- App shell (header / diagnostics) ---

export const getConfigSettingInfo = createAsyncThunk(
  'config/app-settings',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const referrer = sessionStorage.getItem('referrer')

    let url = `/ntapi/v1/configurations/app-settings`

    if (referrer === 'corus') {
      url += `?referrer=${encodeURIComponent(referrer)}`
    }

    return await AxiosClient('GET', url, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const refreshLogLevel = createAsyncThunk(
  'v1/refresh-log-level',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/ntapi/v1/refresh-log-level`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
